module.exports = __webpack_public_path__ + "img/beers_lovers.2dfadf2d.png";